import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { getDnhJobDetails } from "../../../api/dnhJobs.api";

const useJobDetails = (id) => {
    const [jobDetails, setJobDetails] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (id) {
            fetchDetails(id);
        }
    }, [id]);

    const fetchDetails = (jobId) => {
        setLoading(true);
        getDnhJobDetails(jobId, (response) => {
            setLoading(false);
            if (response.status === 200 && response.data) {
                const data = response.data.data || response.data;
                setJobDetails(data);
            } else {
                toast.error("Failed to load job details");
            }
        });
    };

    return {
        jobDetails,
        loading,
        fetchDetails
    }
}

export default useJobDetails
